import React from 'react';

import type { FC } from 'react';

export const Label: FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
      <path d="M11.4213 3.89203C11.1813 3.55203 10.7813 3.33203 10.3346 3.33203L3.0013 3.3387C2.26797 3.3387 1.66797 3.93203 1.66797 4.66536V11.332C1.66797 12.0654 2.26797 12.6587 3.0013 12.6587L10.3346 12.6654C10.7813 12.6654 11.1813 12.4454 11.4213 12.1054L14.3346 7.9987L11.4213 3.89203Z" />
    </svg>
  );
};
